import api from "./Api";

class OrdemServicoSubItemService {
  GetOrdemServicoSubItem(payload) {
    return api.get("/v1/ordemServicoSubItem/" + payload).then((response) => {
      return response.data;
    });
  }

  PostOrdemServicoSubItem(payload) {
    return api.post("/v1/ordemServicoSubItem/", payload).then((response) => {
      return response.data;
    });
  }

  PutOrdemServicoSubItem(payload) {
    return api.put("/v1/ordemServicoSubItem/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteOrdemServicoSubItem(payload) {
    return api.delete("/v1/ordemServicoSubItem/" + payload).then((response) => {
      return response.data;
    });
  }

  GetOrdemServicoSubItemOData(payload) {
    return api.get("/OData/OrdemServicoSubItem" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new OrdemServicoSubItemService();
